import React, {useState} from "react";
import {DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../../misc/SmoothActionBar";
import {autoFormat} from "../../../../project/manage/summary/AutoFormat";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {useAsyncAction} from "nate-react-api-helpers";

export function EditAddressTemplate(props: {
    title: string;

    street: string;
    city: string;
    province?: string;
    postal: string;

    onUpdate(addr: {
        street: string;
        city: string;
        province: string;
        postal: string;
    }): Promise<any>

    onClose(): void;
}) {

    const [street, setStreet] = useState(props.street);
    const [city, setCity] = useState(props.city);
    const [province, setProvince] = useState(props.province || "");
    const [postal, setPostal] = useState(props.postal);

    const updateRef = useSyncedRef(props.onUpdate);
    const closeRef = useSyncedRef(props.onClose);

    const update = useAsyncAction(async (input) => {
        await updateRef.current(input);
        closeRef.current();
    }, []);

    const submit = () => {
        update.callback({
            street: street,
            city: city,
            province: province,
            postal: postal
        });
    };

    return (
        <Dialog2 open onClose={() => props.onClose()} onEnterPress={submit}>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Grid container spacing={2} direction="column">
                    <Grid item><TextField fullWidth label="Street Address" value={street} onChange={e => setStreet(e.target.value)} /></Grid>
                    <Grid item>
                        <Grid container spacing={1}>
                            <Grid item>
                                <TextField label="City" value={city} onChange={e => setCity(e.target.value)} />
                            </Grid>
                            {props.province !== undefined && <Grid item>
                                <TextField style={{width: 80}} label="Province" value={province} onChange={e => setProvince(e.target.value)} />
                            </Grid>}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField
                            style={{width: 100}} label="Postal"
                            value={postal} onChange={e => setPostal(autoFormat(e.target.value, "postal"))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={() => props.onClose()}
                onSubmit={submit}
            />
        </Dialog2>
    )
}